import { render, staticRenderFns } from "./ebike-battery-swap.vue?vue&type=template&id=f4838986&"
import script from "./ebike-battery-swap.vue?vue&type=script&lang=js&"
export * from "./ebike-battery-swap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports